import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const PhoneRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${props => props.theme.spacing.sp8};
`

export const AddressContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: ${props => props.theme.spacing.sp16};

  ${props =>
    !props.hasProvince &&
    css`
      & > div:last-child {
        grid-column: span 2;
      }
    `}
`
